import { JsonObject, JsonProperty } from 'json2typescript';
import TemplateContents from './TemplateContents';

@JsonObject('TemplateHeader')
export default class TemplateHeader {
  constructor() {
    this.order = undefined;
    this.largeCategory = undefined;
    this.largeCategoryCss = undefined;
    this.contentsBodyCss = undefined;
    this.contents = new Array<TemplateContents>();
  }

  @JsonProperty('order')
  public order?: number;

  @JsonProperty('large_category')
  public largeCategory?: string;

  @JsonProperty('large_category_css')
  public largeCategoryCss?: string;

  @JsonProperty('contents_body_css')
  public contentsBodyCss?: string;

  @JsonProperty('contents', [TemplateContents])
  public contents: Array<TemplateContents>;
}
